import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Input,
  rem,
  Select,
  Tooltip,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import {
  IconBarcode,
  IconBuildingSkyscraper,
  IconCalendarCog,
  IconChartCandle,
  IconFileExport,
  IconSearch,
  IconTimeDuration15,
  IconUsersGroup,
} from "@tabler/icons-react";
import {
  repositoryDelivery,
  repositoryMdm,
} from "../../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../../_base/component/_layout/_breadcrumb";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_MDM } from "../../../../config";
import { _localization } from "../../../../config/location";
import { green } from "../../../../const/variables";
import { SelectListItemModel } from "../../../../model/SelectListItem";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ReportExportSupplier = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<WarrantyTrackingItem[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [visible, { toggle, close, open }] = useDisclosure(false);

  //chi nhánh
  const [dataBranchCode, setDataBranchCode] = useState<SelectListItemModel[]>(
    [],
  );
  //nhà cung cấp
  const [dataVendorCode, setDataVendorCode] = useState<ComboboxItem[]>([]);

  const navigate = useNavigate();
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const [selectedTimeFilter, setSelectedTimeFilter] = useState<string | null>(
    _searchJson && checkedPinSearch
      ? (_searchJson?.selectedTimeFilter ?? null)
      : null,
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 2, xl: 2 };
  type WarrantyTrackingItem = {
    maCn: string; // Mã chi nhánh
    tenCn: string; // Tên chi nhánh
    loaiHang: string; // Loại hàng
    nhomKh: string | null; // Nhóm khách hàng
    ngayXuatBh: string; // Ngày xuất bảo hành
    maXuatBhNcc: string; // Mã phiếu xuất bảo hành NCC
    maVach: string; // Mã vạch sản phẩm
    maSp: string; // Mã sản phẩm
    tenSp: string; // Tên sản phẩm
    maNcc: string; // Mã nhà cung cấp
    tenNcc: string; // Tên nhà cung cấp
    ghiChuXuatBh: string | null; // Ghi chú xuất bảo hành
    ngayNhapBh: string; // Ngày nhập bảo hành
    maNhapBhNcc: string; // Mã phiếu nhập bảo hành NCC
    ghiChuNhapBh: string | null; // Ghi chú nhập bảo hành
    maVachMoi: string; // Mã vạch mới sau xử lý
    maSpMoi: string | null; // Mã sản phẩm mới nếu có thay thế
    ttMaVach: string; // Trạng thái mã vạch
    ngayHenTra: string;
    nhanVienBaoHanh: string;
    tenNhanVienBaoHanh: string;
    maNhomVatTu: string;
    tenNhomVatTu: string;
  };
  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      startDateNgayTaoPTNHL:
        _searchJson && checkedPinSearch
          ? _searchJson?.startDateNgayTaoPTNHL
          : "",
      endDateNgayTaoPTNHL:
        _searchJson && checkedPinSearch ? _searchJson?.endDateNgayTaoPTNHL : "",
      startDateNgayXuatBhNcc:
        _searchJson && checkedPinSearch
          ? _searchJson?.startDateNgayXuatBhNcc
          : "",
      endDateNgayXuatBhNcc:
        _searchJson && checkedPinSearch
          ? _searchJson?.endDateNgayXuatBhNcc
          : "",
      startDateNgayNhapBhNcc:
        _searchJson && checkedPinSearch
          ? _searchJson?.startDateNgayNhapBhNcc
          : "",
      endDateNgayNhapBhNcc:
        _searchJson && checkedPinSearch
          ? _searchJson?.endDateNgayNhapBhNcc
          : "",
      maVach: _searchJson && checkedPinSearch ? _searchJson?.maVach : "",
      ttMaVach: _searchJson && checkedPinSearch ? _searchJson?.ttMaVach : "",
      loaiHang: _searchJson && checkedPinSearch ? _searchJson?.loaiHang : "",
    },
  });

  const [search, setSearch] = useState<{ maCn: any[]; MaNcc: any[] }>({
    maCn: _searchJson && checkedPinSearch ? (_searchJson?.maCn ?? []) : [], //chi nhánh
    MaNcc: _searchJson && checkedPinSearch ? (_searchJson?.MaNcc ?? []) : [], //nhà cung cấp
  });

  const handleChangeSearchValue = (value: string[] | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : [],
    }));
  };

  const [dataItemStatusSelect] = useState<any[]>([
    { label: "Test lỗi", value: "Test lỗi" },
    { label: "Đang gửi NCC", value: "Đang gửi nhà cung cấp" },
    { label: "Chờ test", value: "Chờ test" },
    { label: "Đổi mã", value: "Đổi mã" },
    { label: "Test OK", value: "Test OK" },
    { label: "Trả khách", value: "Trả khách" },
  ]);

  const handleTimeFilterChange = (value: string) => {
    setSelectedTimeFilter(value);
    formSeachInput.setValues({
      startDateNgayTaoPTNHL: "",
      endDateNgayTaoPTNHL: "",
      startDateNgayXuatBhNcc: "",
      endDateNgayXuatBhNcc: "",
      startDateNgayNhapBhNcc: "",
      endDateNgayNhapBhNcc: "",
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    // Lấy id chi nhánh của người dùng từ localStorage
    const userLogin = localStorage.getItem("userLogin");
    const branchId = userLogin ? JSON.parse(userLogin).branchId : null;

    let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${
      pagination.pageSize
    }&branchId=${branchId}`;

    // Thêm giá trị tìm kiếm chung
    if (formSeachInput.getValues().KeySearch) {
      url += `&KeySearch=${formSeachInput.getValues().KeySearch}`;
    }

    // Kiểm tra loại thời gian được chọn và thêm cặp ngày tương ứng
    if (selectedTimeFilter === "ngayTaoPTNHL") {
      if (formSeachInput.getValues().startDateNgayTaoPTNHL) {
        url += `&startDateNgayTaoPTNHL=${
          formSeachInput.getValues().startDateNgayTaoPTNHL
        }`;
      }
      if (formSeachInput.getValues().endDateNgayTaoPTNHL) {
        url += `&endDateNgayTaoPTNHL=${
          formSeachInput.getValues().endDateNgayTaoPTNHL
        }`;
      }
    }
    if (selectedTimeFilter === "ngayXuatBhNcc") {
      if (formSeachInput.getValues().startDateNgayXuatBhNcc) {
        url += `&startDateNgayXuatBhNcc=${
          formSeachInput.getValues().startDateNgayXuatBhNcc
        }`;
      }
      if (formSeachInput.getValues().endDateNgayXuatBhNcc) {
        url += `&endDateNgayXuatBhNcc=${
          formSeachInput.getValues().endDateNgayXuatBhNcc
        }`;
      }
    }
    if (selectedTimeFilter === "ngayNhapBhNcc") {
      if (formSeachInput.getValues().startDateNgayNhapBhNcc) {
        url += `&startDateNgayNhapBhNcc=${
          formSeachInput.getValues().startDateNgayNhapBhNcc
        }`;
      }
      if (formSeachInput.getValues().endDateNgayNhapBhNcc) {
        url += `&endDateNgayNhapBhNcc=${
          formSeachInput.getValues().endDateNgayNhapBhNcc
        }`;
      }
    }

    if (formSeachInput.getValues().maVach.length > 0) {
      url += `&MaVach=${formSeachInput.getValues().maVach}`;
    }
    if (formSeachInput.getValues().ttMaVach) {
      url += `&TtMaVach=${formSeachInput.getValues().ttMaVach}`;
    }
    if (formSeachInput.getValues().loaiHang) {
      url += `&LoaiHang=${formSeachInput.getValues().loaiHang}`;
    }

    if (search.MaNcc && search.MaNcc.length > 0) {
      search.MaNcc.forEach((maNcc) => {
        url += `&MaNcc=${maNcc}`;
      });
    }

    if (search.maCn && search.maCn.length > 0) {
      search.maCn.forEach((maCn) => {
        url += `&maCn=${maCn}`;
      });
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/WarrantyInfo/warranty-tracking${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...formSeachInput.getValues(),
          ...search,
          selectedTimeFilter: selectedTimeFilter,
        }),
      );
    }
  };

  // Lấy danh sách mã chi nhánh
  const DataBranchCode = async () => {
    try {
      const response = await repositoryDelivery.get(
        `api/v1/TblDmMasterOrg/get-select`,
      );

      if (response && response.success) {
        const transformedData = response.data.map((item: any) => ({
          value: item.att1,
          label: item.att1 + " - " + item.text,
        }));
        setDataBranchCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  // Lấy danh sách nhà cung cấp
  const DataVendorCode = async () => {
    try {
      const response = await repositoryMdm.get("/api/v1/TblVendor/get-all");
      if (response && response.success) {
        const transformedData = response.data.map((item: any) => ({
          value: String(item.vendorCode),
          label: item.id + " - " + item.vendorCode,
        }));
        setDataVendorCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  //Export data to Excel
  const exportDataExcel = async () => {
    open();
    try {
      const userLogin = localStorage.getItem("userLogin");
      const branchId = userLogin ? JSON.parse(userLogin).branchId : null;

      let url = `/api/v1/WarrantyInfo/export-warranty-tracking?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}&branchId=${branchId}`;
      if (selectedTimeFilter === "ngayTaoPTNHL") {
        if (formSeachInput.getValues().startDateNgayTaoPTNHL.length > 0) {
          url += `&startDateNgayTaoPTNHL=${
            formSeachInput.getValues().startDateNgayTaoPTNHL
          }`;
        }

        if (formSeachInput.getValues().endDateNgayTaoPTNHL.length > 0) {
          url += `&endDateNgayTaoPTNHL=${
            formSeachInput.getValues().endDateNgayTaoPTNHL
          }`;
        }
      }
      if (selectedTimeFilter === "ngayXuatBhNcc") {
        if (formSeachInput.getValues().startDateNgayXuatBhNcc.length > 0) {
          url += `&startDateNgayXuatBhNcc=${
            formSeachInput.getValues().startDateNgayXuatBhNcc
          }`;
        }

        if (formSeachInput.getValues().endDateNgayXuatBhNcc.length > 0) {
          url += `&endDateNgayXuatBhNcc=${
            formSeachInput.getValues().endDateNgayXuatBhNcc
          }`;
        }
      }
      if (selectedTimeFilter === "ngayNhapBhNcc") {
        if (formSeachInput.getValues().startDateNgayNhapBhNcc.length > 0) {
          url += `&startDateNgayNhapBhNcc=${
            formSeachInput.getValues().startDateNgayNhapBhNcc
          }`;
        }

        if (formSeachInput.getValues().endDateNgayNhapBhNcc.length > 0) {
          url += `&endDateNgayNhapBhNcc=${
            formSeachInput.getValues().endDateNgayNhapBhNcc
          }`;
        }
      }
      if (formSeachInput.getValues().KeySearch.length > 0) {
        url += `&KeySearch=${formSeachInput.getValues().KeySearch}`;
      }
      if (formSeachInput.getValues().maVach.length > 0) {
        url += `&MaVach=${formSeachInput.getValues().maVach}`;
      }
      if (formSeachInput.getValues().ttMaVach) {
        url += `&TtMaVach=${formSeachInput.getValues().ttMaVach}`;
      }
      if (formSeachInput.getValues().loaiHang) {
        url += `&LoaiHang=${formSeachInput.getValues().loaiHang}`;
      }

      if (search.MaNcc && search.MaNcc.length > 0) {
        search.MaNcc.forEach((MaNcc) => {
          url += `&MaNcc=${MaNcc}`;
        });
      }
      if (search.maCn && search.maCn.length > 0) {
        search.maCn.forEach((maCn) => {
          url += `&maCn=${maCn}`;
        });
      }

      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }
      const blob = await response.blob();
      const urlss = window.URL.createObjectURL(blob);
      const _name = new Date().toISOString().slice(0, 10);
      let filename = "bao_cao_xuat_gui_NCC_" + _name + ".xlsx";
      const link = document.createElement("a");
      link.href = urlss;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("error", error);
    } finally {
      close();
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<WarrantyTrackingItem>[]>(
    () => [
      {
        accessorKey: "maCn",
        header: "Mã chi nhánh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenCn",
        header: "Tên chi nhánh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "loaiHang",
        header: "Loại hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "nhomKh",
        header: "Nhóm khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ngayXuatBh",
        header: "Ngày xuất bảo hành",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        sortingFn: (a, b) => {
          const dateA = new Date(a.original.ngayXuatBh);
          const dateB = new Date(b.original.ngayXuatBh);
          return dateA.getTime() - dateB.getTime();
        },
      },
      {
        accessorKey: "maXuatBhNcc",
        header: "Mã phiếu xuất bảo hành NCC",
        size: 250,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              variant="dot"
              radius="xs"
              size="md"
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => {
                navigate("/warehouse-config/detail-warehouse-out-ward", {
                  state: {
                    transactionCode: renderedCellValue,
                    type: "XUAT_KHO_BAO_HANH_NCC",
                    isLocked: true,
                  },
                });
              }}
              style={{ cursor: "pointer" }}
            >
              {renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "maVach",
        header: "Mã vạch",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenSp",
        header: "Tên sản phẩm",
        size: 400,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maNcc",
        header: "Mã nhà cung cấp",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenNcc",
        header: "Tên nhà cung cấp",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ghiChuXuatBh",
        header: "Ghi chú xuất bảo hành",
        size: 200,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ngayNhapBh",
        header: "Ngày nhập bảo hành",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        sortingFn: (a, b) => {
          const dateA = new Date(a.original.ngayNhapBh);
          const dateB = new Date(b.original.ngayNhapBh);
          return dateA.getTime() - dateB.getTime();
        },
      },
      {
        accessorKey: "numOfDays",
        header: "Số ngày gửi BH NCC",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maNhapBhNcc",
        header: "Mã phiếu nhập bảo hành NCC",
        size: 250,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              variant="dot"
              radius="xs"
              size="md"
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => {
                navigate("/warehouse-config/detail-warehouse-in-ward", {
                  state: {
                    transactionCode: renderedCellValue,
                    sourceType: "NHAP_KHO_BAO_HANH_NCC",
                    isLocked: true,
                  },
                });
              }}
              style={{ cursor: "pointer" }}
            >
              {renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "ghiChuNhapBh",
        header: "Ghi chú nhập bảo hành",
        size: 225,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maVachMoi",
        header: "Mã vạch mới",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maSpMoi",
        header: "Mã sản phẩm mới",
        size: 170,
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              variant="dot"
              radius="xs"
              size="md"
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "ttMaVach",
        header: "Trạng thái mã vạch",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ngayHenTra",
        header: "Ngày hẹn trả",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        sortingFn: (a, b) => {
          const dateA = new Date(a.original.ngayHenTra);
          const dateB = new Date(b.original.ngayHenTra);
          return dateA.getTime() - dateB.getTime();
        },
      },
      {
        accessorKey: "nhanVienBaoHanh",
        header: "Nhân viên bảo hành",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenNhanVienBaoHanh",
        header: "Tên nhân viên bảo hành",
        size: 225,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maNhomVatTu",
        header: "Mã nhóm vật tư",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenNhomVatTu",
        header: "Tên nhóm vật tư",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
    ],
    [],
  );

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningReportExportSupplier",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: [],
          right: [],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningReportExportSupplier",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableRowNumbers: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
      columnPinning,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    DataBranchCode();
    DataVendorCode();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (190 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
        <Button
          leftSection={
            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
          }
          onClick={() => exportDataExcel()}
        >
          Export Excel
        </Button>
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Mã vạch"
              type="text"
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              key={formSeachInput.key("MaVach")}
              {...formSeachInput.getInputProps("maVach")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chọn loại thời gian"
              data={[
                // { value: "ngayTaoPTNHL", label: "Ngày tạo phiếu tiếp nhận hàng lỗi" },
                { value: "ngayXuatBhNcc", label: "Ngày xuất bảo hành" },
                { value: "ngayNhapBhNcc", label: "Ngày nhập bảo hành" },
              ]}
              value={selectedTimeFilter}
              onChange={(value) => handleTimeFilterChange(value || "")}
              leftSection={<IconCalendarCog size={20} color="#15aabf" />}
              clearable
            />
          </Grid.Col>

          {selectedTimeFilter === "ngayTaoPTNHL" && (
            <>
              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  size="sm"
                  placeholder="Từ ngày tạo phiếu"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                  defaultValue={
                    formSeachInput.getValues().startDateNgayTaoPTNHL
                      ? new Date(
                          formSeachInput.getValues().startDateNgayTaoPTNHL,
                        )
                      : null
                  }
                  onChange={(date) => {
                    formSeachInput.setFieldValue(
                      "startDateNgayTaoPTNHL",
                      date ? formatDateNotTimeZone(date) : "",
                    );
                  }}
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  size="sm"
                  placeholder="Đến ngày tạo phiếu"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                  defaultValue={
                    formSeachInput.getValues().endDateNgayTaoPTNHL
                      ? new Date(formSeachInput.getValues().endDateNgayTaoPTNHL)
                      : null
                  }
                  onChange={(date) => {
                    formSeachInput.setFieldValue(
                      "endDateNgayTaoPTNHL",
                      date ? formatDateNotTimeZone(date) : "",
                    );
                  }}
                  clearable
                />
              </Grid.Col>
            </>
          )}

          {selectedTimeFilter === "ngayXuatBhNcc" && (
            <>
              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  size="sm"
                  placeholder="Từ ngày xuất bảo hành"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                  defaultValue={
                    formSeachInput.getValues().startDateNgayXuatBhNcc
                      ? new Date(
                          formSeachInput.getValues().startDateNgayXuatBhNcc,
                        )
                      : null
                  }
                  onChange={(date) => {
                    formSeachInput.setFieldValue(
                      "startDateNgayXuatBhNcc",
                      date ? formatDateNotTimeZone(date) : "",
                    );
                  }}
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  size="sm"
                  placeholder="Đến ngày xuất bảo hành"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                  defaultValue={
                    formSeachInput.getValues().endDateNgayXuatBhNcc
                      ? new Date(
                          formSeachInput.getValues().endDateNgayXuatBhNcc,
                        )
                      : null
                  }
                  onChange={(date) => {
                    formSeachInput.setFieldValue(
                      "endDateNgayXuatBhNcc",
                      date ? formatDateNotTimeZone(date) : "",
                    );
                  }}
                  clearable
                />
              </Grid.Col>
            </>
          )}

          {selectedTimeFilter === "ngayNhapBhNcc" && (
            <>
              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  size="sm"
                  placeholder="Từ ngày nhập bảo hành"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                  defaultValue={
                    formSeachInput.getValues().startDateNgayNhapBhNcc
                      ? new Date(
                          formSeachInput.getValues().startDateNgayNhapBhNcc,
                        )
                      : null
                  }
                  onChange={(date) => {
                    formSeachInput.setFieldValue(
                      "startDateNgayNhapBhNcc",
                      date ? formatDateNotTimeZone(date) : "",
                    );
                  }}
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  size="sm"
                  placeholder="Đến ngày nhập bảo hành"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                  defaultValue={
                    formSeachInput.getValues().endDateNgayNhapBhNcc
                      ? new Date(
                          formSeachInput.getValues().endDateNgayNhapBhNcc,
                        )
                      : null
                  }
                  onChange={(date) => {
                    formSeachInput.setFieldValue(
                      "endDateNgayNhapBhNcc",
                      date ? formatDateNotTimeZone(date) : "",
                    );
                  }}
                  clearable
                />
              </Grid.Col>
            </>
          )}

          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Vui lòng chọn chi nhánh"
              searchable
              clearable
              leftSection={<IconBuildingSkyscraper size={20} color="#15aabf" />}
              data={dataBranchCode}
              value={
                search.maCn && search.maCn.length > 0 ? search.maCn[0] : null
              }
              onChange={(value) =>
                handleChangeSearchValue(value ? [value] : null, "maCn")
              } // Cập nhật chi nhánh
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Vui lòng chọn nhà cung cấp"
              searchable
              clearable
              leftSection={<IconUsersGroup size={20} color="#15aabf" />}
              data={dataVendorCode}
              value={
                search.MaNcc && search.MaNcc.length > 0 ? search.MaNcc[0] : null
              }
              onChange={(value) =>
                handleChangeSearchValue(value ? [value] : null, "MaNcc")
              } // Cập nhật nhà cung cấp
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Loại hàng"
              defaultValue={formSeachInput.getValues().loaiHang || null}
              data={[
                {
                  value: "Hàng ngoài",
                  label: "Hàng ngoài",
                },
                {
                  value: "Hàng kho",
                  label: "Hàng kho",
                },
              ]}
              leftSection={<IconChartCandle color="#15aabf" />}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => {
                formSeachInput.setFieldValue("loaiHang", e ? e : "");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Trạng thái mã vạch"
              defaultValue={formSeachInput.getValues().ttMaVach || null}
              data={dataItemStatusSelect}
              leftSection={<IconChartCandle color="#15aabf" />}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => {
                formSeachInput.setFieldValue("ttMaVach", e ? e : "");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>{" "}
          </Grid.Col>
        </Grid>
      </Box>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default ReportExportSupplier;
